/**
 * dev 오버레이를 이 브라우저에서 켤지 — localStorage 플래그 하나다.
 *
 * **이 플래그는 보안 장치가 아니다.** 권한은 서버가 판단하고
 * (`apps/api/src/routes/admin-dev.ts` — `dev:access` 없으면 403, env 없으면 404),
 * 여기는 *이 브라우저에 오버레이를 띄울지*만 정한다. 누가 손으로 켜도 오버레이가 하는 일은
 * 라우트 이동·자기 브라우저의 요청 로그·자기 콘솔 에러뿐이라 개발자도구로 이미 볼 수 있는 것들이다.
 *
 * **오버레이 코드가 산출물에 들어갈지는 빌드가 정한다**(`App.tsx`의 `DEV_PANEL_IN_BUILD`,
 * 기획 §15-3). 이 플래그는 그 안에서의 개인 토글이다 — 켜져 있어야 lazy 청크를 받는다.
 */

const KEY = 'haebom.devPanel'

/** App이 이 이벤트로 마운트·언마운트를 따라간다(같은 탭에서는 storage 이벤트가 안 온다). */
export const DEV_FLAG_EVENT = 'haebom:dev-flag'

export function isDevPanelOn(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch {
    // 사파리 프라이빗 등 저장소가 막힌 환경 — 꺼진 것으로 본다(조용히 넘기되 기능은 정상).
    return false
  }
}

/**
 * `?devpanel=1`(켜기) · `?devpanel=0`(끄기).
 *
 * 플래그를 켜는 **정본 경로는 `/admin/dev` 화면의 토글**이고 이건 편의 경로다.
 * 2026-08-19 원클릭 로그인을 없애면서 플래그를 켤 곳이 사라졌기 때문에 둘 다 만들었다(기획 §15-3).
 * 오버레이가 빌드에 없으면 값이 남아도 아무 일도 일어나지 않는다.
 */
export function applyDevFlagFromQuery(search: string): void {
  const v = new URLSearchParams(search).get('devpanel')
  if (v === '1') setDevPanelOn(true)
  else if (v === '0') setDevPanelOn(false)
}

export function setDevPanelOn(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, '1')
    else window.localStorage.removeItem(KEY)
  } catch {
    /* 저장이 안 되면 이번 세션에만 안 남는다 — 화면 동작은 아래 이벤트로 이어진다. */
  }
  window.dispatchEvent(new Event(DEV_FLAG_EVENT))
}
